import { attach } from 'effector';

import { api } from '@shared/api';

const deleteFileFx = attach({ effect: api.files.deleteFile });

export { deleteFileFx };
